import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=0bc2b384&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=ts&"
export * from "./Index.vue?vue&type=script&lang=ts&"
import style1 from "./Index.vue?vue&type=style&index=1&id=0bc2b384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc2b384",
  null
  
)

export default component.exports